import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { post, get } from '../../../../utils/networking'
import moment from 'moment'
import './style.css'
export default class MyServices extends Component {

    constructor(props) {
        super(props)

        this.state = {
            services: [],
            acctiveTab: -1,
            isLoaded: false,
            defaultStoreSlug: ""
        }

    }

    componentDidMount() {
        get('/user/serviceHistory', "customer", result => {
            this.setState({
                services: result,
                isLoaded: true
            })
        }, errors => {
            this.setState({
                isLoaded: true
            })
        })
    }

    render() {

        let {
            services,
            acctiveTab,
            isLoaded,
        } = this.state;

        return (
            <div>
                {
                    (isLoaded) ? <div className="box box-primary">
                        {
                            (services.length > 0) ? <div className="service_history">
                                <span className="title">History for all of your services</span>
                                <table className="history_table">
                                    <th>
                                        <td className="date" style={{ width: "20%" }}>DATE</td>
                                        <td className="name" style={{ width: "50%" }}>SERIVE NAME</td>
                                        <td className="price" style={{ width: "15%" }}>PRICE</td>
                                        <td className="point" style={{ width: "15%" }}>POINT</td>
                                    </th>
                                    <tbody>

                                        {
                                            services.map((item, i) =>
                                                <tr key={i} className={(i % 2 == 1) ? "recore_odd" : ""}>
                                                    <td colSpan={4}>
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="date" style={{ width: "20%" }}>{moment(item.dateTime).format("MM/DD/YYYY")}</td>
                                                                    <td className="name" style={{ width: "50%" }}>{item.name}</td>
                                                                    <td className="price" style={{ width: "15%" }}>${item.amount}</td>
                                                                    <td className="point" style={{ width: "15%" }}>{(item.point) ? item.point : "0"}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div>
                                                            <span className="bt_detail" onClick={() => this.setState({ acctiveTab: (acctiveTab == i) ? (-1) : i })}>{(acctiveTab == i) ? "CLOSE" : "VIEW DETAIL"}</span>
                                                            <div className={(acctiveTab == i) ? "service_detail active" : "service_detail"}>
                                                                <span>ID: {item.id}</span>
                                                                <span className="point">Accumulation point: {(item.point) ? item.point : "0"}</span>
                                                                <span>Staff: {item.staffName}</span>
                                                                <span>Description: {item.note}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                            </div> : <div className="service-empty">
                                    <span>You have not used the service of any store.</span>
                                    <NavLink to="/spa?keyword=&location=">Book appointment now</NavLink>
                                </div>
                        }
                    </div> : <div>
                            <div className="spinner">
                                <div className="rect1"></div>
                                <div className="rect2"></div>
                                <div className="rect3"></div>
                                <div className="rect4"></div>
                                <div className="rect5"></div>
                            </div>
                        </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/user/overview/myServices/index.js